import ng from "angular";
import { IdSvrAuthService } from "../../../../auth/idSrvAuthService";
import { ForecastService } from "../../services/forecastService";

class ForecastSelectorPopUpComponentController implements ng.IController {
    static $inject = [ForecastService.componentName, IdSvrAuthService.componentName];

    resolve: $TSFixMe;
    close: (args: { $value: $TSFixMe }) => void;
    dismiss: (args: { $value: $TSFixMe }) => void;
    forecasts: $TSFixMe[];
    filter: { budgetYear: number; showMy: boolean; name?: string };
    brands: $TSFixMe[] = [];
    selectedBrand: $TSFixMe = null;
    loadingAssumptions: ng.IPromise<$TSFixMe>;
    canSeeOthersForecasts: boolean;

    constructor(private forecastService: ForecastService, private authService: IdSvrAuthService) {}

    $onInit() {
        this.filter = {
            budgetYear: new Date().getFullYear() + 1,
            showMy: true
        };

        const permissionsResult = this.authService.hasPermissions(
            "ViewAllDraftForecastFromIMSMarket",
            "ViewAllDraftForecastFromFileMarket",
            "ViewAllDraftForecastFromScoringCardsMarket",
            "ViewAllDraftForecastFromScoringCardsPolandMarket",
            "ViewAllCreatedForecastFromIMSMarket",
            "ViewAllCreatedForecastFromFileMarket",
            "ViewAllCreatedForecastFromScoringCardMarket",
            "ViewAllCreatedForecastFromScoringCardPolandMarket"
        );

        this.canSeeOthersForecasts =
            permissionsResult.ViewAllDraftForecastFromFileMarket &&
            permissionsResult.ViewAllDraftForecastFromIMSMarket &&
            permissionsResult.ViewAllDraftForecastFromScoringCardsMarket &&
            permissionsResult.ViewAllDraftForecastFromScoringCardsPolandMarket &&
            permissionsResult.ViewAllCreatedForecastFromIMSMarket &&
            permissionsResult.ViewAllCreatedForecastFromFileMarket &&
            permissionsResult.ViewAllCreatedForecastFromScoringCardMarket &&
            permissionsResult.ViewAllCreatedForecastFromScoringCardPolandMarket;
    }

    findForecast(searchString: string) {
        this.filter.name = searchString;
        this.forecastService.searchForecast(this.filter).then((items: $TSFixMe[]) => {
            this.forecasts = items;
        });
    }

    forecastSelected(model: $TSFixMe) {
        if (model) {
            this.loadingAssumptions = this.forecastService.get(model.id).then((response: $TSFixMe) => {
                this.brands = response.data.jsonData.market.brands;
                if (this.brands.length === 1) {
                    this.selectedBrand = this.brands[0];
                }
            });
        } else {
            this.brands = [];
            this.selectedBrand = null;
        }
    }

    ok() {
        this.close({ $value: this.selectedBrand.assumptions });
    }

    cancel() {
        this.dismiss({ $value: "cancel" });
    }
}

export class ForecastSelectorPopUpComponent implements ng.IComponentOptions {
    static componentName = "forecastSelectorPopUp";
    bindings = {
        resolve: "<",
        close: "&",
        dismiss: "&"
    };
    template = require("./forecastSelectorPopUpComponent.html");

    controller = ForecastSelectorPopUpComponentController;
}

angular
    .module("topline.modules")
    .component(ForecastSelectorPopUpComponent.componentName, new ForecastSelectorPopUpComponent());
